var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-container"},_vm._l((_vm.mlList),function(item,index){return _c('div',{key:index,staticClass:"ml-item",class:{
      'item-text': item.type == 'text',
      'item-line': item.type == 'line',
      'item-none': item.type == 'none',
      'item-last': item.last
    },style:({ width: _vm.width + 'px' })},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }